import React from 'react';
import { Grid, Paper, Typography, Box, IconButton } from '@mui/material';
import {
  TrendingUp,
  TrendingDown,
  ShowChart,
  CalendarToday,
} from '@mui/icons-material';
import './summaryGrid.css';

interface SummaryItem {
  title: string;
  value: string;
  trend?: 'up' | 'down' | 'neutral';
  trendValue?: string;
  icon?: 'calendar' | 'chart' | 'forecast' | 'average';
  description?: string;
}

interface SummaryGridProps {
  summaryData: SummaryItem[];
  currency?: string;
}

const SummaryGrid: React.FC<SummaryGridProps> = ({
  summaryData,
  currency = '$',
}) => {
  const getIcon = (iconType?: string) => {
    switch (iconType) {
      case 'calendar':
        return <CalendarToday className="summaryIcon" />;
      case 'chart':
        return <ShowChart className="summaryIcon" />;
      case 'forecast':
        return <TrendingUp className="summaryIcon" />;
      case 'average':
        return <ShowChart className="summaryIcon" />;
      default:
        return <ShowChart className="summaryIcon" />;
    }
  };

  // const getTrendIcon = (trend?: string) => {
  //   switch (trend) {
  //     case 'up':
  //       return <TrendingUp className="trendIconUp" />;
  //     case 'down':
  //       return <TrendingDown className="trendIconDown" />;
  //     default:
  //       return null;
  //   }
  // };

  // const getTrendClass = (trend?: string) => {
  //   switch (trend) {
  //     case 'up':
  //       return 'trendUp';
  //     case 'down':
  //       return 'trendDown';
  //     default:
  //       return 'trendNeutral';
  //   }
  // };

  return (
    <div className="summaryGridContainer">
      <Grid container spacing={3}>
        {summaryData.map((item, index) => (
          <Grid item xs={12} sm={6} md={3} key={index}>
            <Paper className="summaryCard" elevation={2}>
              <Box display={'flex'} justifyContent={'space-between'}>
                <Box className="summaryCardHeader">
                  <div className="summaryIconContainer">
                    {getIcon(item.icon)}
                  </div>
                  <div className="summaryTitleContainer">
                    <Typography className="summaryTitle" variant="body2">
                      {item.title}
                    </Typography>
                    {item.description && (
                      <Typography
                        className="summaryDescription"
                        variant="caption"
                      >
                        {item.description}
                      </Typography>
                    )}
                  </div>
                </Box>

                <Box className="summaryValueContainer">
                  <Typography className="summaryValue" variant="h4">
                    {currency}
                    {item.value}
                  </Typography>

                  {/* {item.trend && item.trendValue && (
                  <Box className={`summaryTrend ${getTrendClass(item.trend)}`}>
                    {getTrendIcon(item.trend)}
                    <p className="trendValue">{item.trendValue}</p>
                  </Box>
                )} */}
                </Box>
              </Box>

              <div className="summaryCardOverlay"></div>
            </Paper>
          </Grid>
        ))}
      </Grid>
    </div>
  );
};

export default SummaryGrid;
